// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___cd25049a864b01b3cf7","cls2":"Comments-cls2___674cabe58c3a7275ca0 Comments-cls1___cd25049a864b01b3cf7"};